import React from 'react';
import LBModel from './lightBoxModel';
import ImgSlider from './imgSlider';
import {FiEye} from 'react-icons/fi';
import Gallery from '../../models/gallery.model';

interface LBInterface{
  images:Array<Gallery>,
  active:number
}

const LightBox:React.FC<LBInterface>= props => {

  const {images,active} = props;

  const [activeIndex,setActiveIndex] = React.useState<number>(0);
  const [showModel,setShowModel] = React.useState<boolean>(false);

  const closeModel = ()=>{
    document.body.classList.remove('ecn-lb-model-open');
    setActiveIndex(0);
    setShowModel(false);
  }

  const openModel = ()=>{
    document.body.classList.add('ecn-lb-model-open');
    setActiveIndex(active);
    setShowModel(true);
  }
  

  const prev = () =>{
    if(images.length){
      const count = images.length;
      if(activeIndex<=0) setActiveIndex(count-1);
      else setActiveIndex(activeIndex-1);
    }
  }

  const next = () =>{
    if(images.length){
      const count = images.length;
      if(activeIndex >= count-1) setActiveIndex(0);
      else setActiveIndex(activeIndex+1);
    }
  }


  return(
    <>
    <FiEye onClick={openModel}/>

    {showModel?
       <LBModel  visible={showModel} closeModel={closeModel}>
        <ImgSlider 
          images={images}
          active={activeIndex}
          previous={prev}
          next={next}
        />
      </LBModel>:''
    }
   
    </>
  );
}


export default LightBox;